var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canView
    ? _c(
        "div",
        {
          staticClass: "report-card-container col-xl-4 col-lg-6 col-md-6 mb-4",
        },
        [
          _c(
            "div",
            { staticClass: "report-card", on: { click: _vm.navigate } },
            [
              _c("div", { staticClass: "card-gradient" }),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "card-icon-wrapper" }, [
                  _c("i", {
                    class: [_vm.icon || "fas fa-file-alt", "card-icon"],
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c("h5", { staticClass: "card-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _vm._v(" "),
                  _vm.description
                    ? _c("p", { staticClass: "card-description" }, [
                        _vm._v(_vm._s(_vm.description)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-action" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.btnText || _vm.Lang.get("messages.view_report")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fas fa-arrow-right ml-2 action-arrow",
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-decoration" }, [
                _c("i", { class: _vm.icon || "fas fa-file-alt" }),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }